// src/pages/gears/Neo.js

import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import AffiliateAmazon from "../../components/affiliate/AffiliateAmazon";
import AffiliateEbay from "../../components/affiliate/AffiliateEbay";
import React, { useState } from "react";

// ⭐ IMPORT ONLY THE IMAGES YOU NEED
import droneImg from "./gearimages/gpmax.jpg";

export default function GoproMax() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>

      <div className="page-container" style={{ padding: "10px" }}>
        <section className="gear-review">

          {/* ⭐ NEW GEAR LAYOUT */}
          <div className="gear-container">

            {/* LEFT COLUMN */}
            <div className="gear-left">
              <h1>GoPro Max</h1>

              <p>
                The GoPro Max is GoPro’s most versatile 360° action camera, combining immersive 
                5.6K spherical video with the rugged durability GoPro is known for. With dual 
                lenses, you can capture everything around you and reframe later in the GoPro 
                app — perfect for travel, action sports, and creative storytelling.
              </p>

              <p>
                Max HyperSmooth stabilization, horizon leveling, and TimeWarp 360 make the Max 
                incredibly smooth and cinematic, even in fast‑moving environments. Whether you're 
                hiking, biking, snorkeling, or vlogging, the GoPro Max delivers sharp video, 
                excellent audio, and a unique creative workflow that traditional action cameras 
                can’t match.
              </p>

              <div className="place-block">
                <ul>
                  <li>5.6K 360° video at 30fps</li>
                  <li>Max HyperSmooth stabilization + horizon leveling</li>
                  <li>Single‑lens HERO mode (up to 1440p60)</li>
                  <li>Waterproof up to 5 m (16 ft) without a case</li>
                  <li>Front‑facing touchscreen for vlogging</li>
                  <li>6‑mic immersive audio with wind reduction</li>
                  <li>TimeWarp 360 + PowerPano photo mode</li>
                  <li>Built‑in mounting fingers (no frame needed)</li>
                  <li>Approx. 70–80 minutes of recording per charge (varies by mode)</li>
                </ul>
              </div>

              <AffiliateAmazon
                title="Check price on Amazon"
                link="https://amzn.to/4dI2CPM"
              />

              <AffiliateEbay
              title="Check price on eBay"
                link="https://ebay.us/5275oM"
              />
            </div>

            {/* RIGHT COLUMN */}
            <div className="gear-right">
              <img src={droneImg} alt="GoPro Max 360 camera" />
            </div>

          </div>
        </section>
      </div>

      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
